import type { IInputBoolModelValueType, IInputBoolPropsWithoutModelValue } from '@/components';
import { reactive, type Ref } from 'vue';
import { DropdownItemBase } from './DropdownItemBase';

type IDropdownItemCheckbox = {
    [K in keyof IInputBoolPropsWithoutModelValue]: undefined extends IInputBoolPropsWithoutModelValue[K]
        ? IInputBoolPropsWithoutModelValue[K] | Ref<Exclude<IInputBoolPropsWithoutModelValue[K], undefined>> | undefined
        : IInputBoolPropsWithoutModelValue[K] | Ref<IInputBoolPropsWithoutModelValue[K]>;
};

export class DropdownItemCheckbox extends DropdownItemBase {
    modelValue: Ref<IInputBoolModelValueType>;

    props: IInputBoolPropsWithoutModelValue;

    get uniqueLoopKey() {
        return `${this.props.label}-${this.props.tooltip}-${this.props.subtext}`;
    }

    private loopkey?: string;

    /**
     * This is here so a pojo wont fit the class, and thus we get build errors if we havent used the create method
     */
    private abuseBlocker: boolean = false;

    private constructor(
        modelValue: Ref<IInputBoolModelValueType>,
        props: IDropdownItemCheckbox,
        hideDropDownItem?: Ref<boolean>,
        uniqueLoopKey?: string,
    ) {
        super();
        this.modelValue = modelValue;
        this.hideDropDownItem = hideDropDownItem;

        this.loopkey = uniqueLoopKey;

        this.props = reactive(props);
    }

    public static create(
        options: { modelValue: Ref<IInputBoolModelValueType> } & IDropdownItemCheckbox &
            Partial<Pick<DropdownItemBase, 'hideDropDownItem' | 'uniqueLoopKey'>>,
    ): DropdownItemCheckbox {
        const { modelValue, hideDropDownItem, uniqueLoopKey, ...props } = options;

        return new DropdownItemCheckbox(modelValue, props, hideDropDownItem, uniqueLoopKey);
    }
}
